import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../../../contexts/LanguageContext';

const DraftWarrantyClaimsDialog = ({ visible, onHide, customerStatementId, data }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();

    const items = data?.items || [];

    const handleNavigateToClaim = (claimId) => {
        navigate(`/warranty-management/warranty-requests/claims/${claimId}`);
        onHide();
    };

    // Claim ID'leri göster (virgülle ayrılmış, tıklanabilir)
    const claimIdsBodyTemplate = (rowData) => {
        const claimIds = rowData.claimIds || [];
        if (claimIds.length === 0) return '-';

        return (
            <div className="flex flex-wrap gap-1">
                {claimIds.map((id) => (
                    <Tag
                        key={id}
                        value={
                            <span className="flex align-items-center gap-1">
                                <i className="pi pi-external-link" style={{ fontSize: '0.7rem' }} />
                                #{id}
                            </span>
                        }
                        className="cursor-pointer hover:shadow-2"
                        severity="info"
                        onClick={() => handleNavigateToClaim(id)}
                        title={t('warranty.customerDeclaration.draftClaims.clickToView')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(59, 130, 246, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    />
                ))}
            </div>
        );
    };

    const warrTypeBodyTemplate = (rowData) => {
        const type = rowData.warrType || '-';
        return <Tag value={type} severity="warning" />;
    };

    const renderContent = () => {
        if (items.length === 0) {
            return (
                <div className="flex justify-content-center align-items-center p-5">
                    <div className="text-center">
                        <i className="pi pi-inbox text-4xl text-400 mb-3" />
                        <p className="text-600">{t('warranty.customerDeclaration.draftClaims.emptyMessage')}</p>
                    </div>
                </div>
            );
        }

        return (
            <>
                {/* Bilgilendirme mesajı */}
                <div className="flex align-items-center gap-2 mb-3 p-3 border-round"
                    style={{ backgroundColor: 'var(--blue-50)', border: '1px solid var(--blue-200)' }}>
                    <i className="pi pi-info-circle text-blue-500" />
                    <span className="text-blue-700 text-sm">
                        {t('warranty.customerDeclaration.draftClaims.clickHint')}
                    </span>
                </div>

                <DataTable
                    value={items}
                    className="p-datatable-gridlines"
                    showGridlines
                    dataKey="warrClaimsNo"
                    emptyMessage={t('warranty.customerDeclaration.draftClaims.emptyMessage')}
                    tableStyle={{ minWidth: '40rem' }}
                    size="small"
                >
                    <Column
                        field="warrClaimsNo"
                        header={t('warranty.customerDeclaration.draftClaims.claimNo')}
                        style={{ width: '20%' }}
                        body={(rowData) => (
                            <span className="font-semibold text-primary">
                                {rowData.warrClaimsNo || '-'}
                            </span>
                        )}
                    />
                    <Column
                        field="claimIds"
                        header={
                            <span className="flex align-items-center gap-1">
                                {t('warranty.customerDeclaration.draftClaims.claimIds')}
                                <i className="pi pi-external-link text-xs text-500"
                                    title={t('warranty.customerDeclaration.draftClaims.clickableHint')} />
                            </span>
                        }
                        style={{ width: '30%' }}
                        body={claimIdsBodyTemplate}
                    />
                    <Column
                        field="warrType"
                        header={t('warranty.customerDeclaration.draftClaims.warrantyType')}
                        style={{ width: '20%' }}
                        body={warrTypeBodyTemplate}
                    />
                    <Column
                        field="createdName"
                        header={t('warranty.customerDeclaration.draftClaims.createdBy')}
                        style={{ width: '30%' }}
                    />
                </DataTable>
            </>
        );
    };

    const footerContent = (
        <div className="flex justify-content-end">
            <Button
                label={t('common.close')}
                icon="pi pi-times"
                onClick={onHide}
                className="p-button-text"
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            header={
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-file-edit text-orange-500" />
                    <span>{t('warranty.customerDeclaration.draftClaims.title')}</span>
                    {items.length > 0 && (
                        <Tag value={items.length} severity="warning" className="ml-2" />
                    )}
                </div>
            }
            modal
            onHide={onHide}
            style={{ width: '60vw', maxWidth: '800px' }}
            footer={footerContent}
            className="draft-warranty-claims-dialog"
        >
            {renderContent()}
        </Dialog>
    );
};

export default DraftWarrantyClaimsDialog;
